import { getShellContentScrollElement } from 'shared/shell_content_scroll_registry'

export const MEETINGS_FEED_TOP_CSS_VAR = '--meetings-feed-top'
const MEETING_GROUP_SCROLL_OFFSET_VAR = '--meeting-group-scroll-offset'
const MEETINGS_PRESET_TABS_BAND_VAR = '--meetings-preset-tabs-band'
const DEFAULT_FEED_TOP_PX = 164

const readCssPxVar = (name: string): number => {
  if (typeof window === 'undefined') return 0
  const parsed = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name))
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0
}

/** Bottom edge of the meeting table (preset row), in viewport coordinates. */
export const getMeetingsFeedTopPx = (): number => {
  const fromFeedTopVar = readCssPxVar(MEETINGS_FEED_TOP_CSS_VAR)
  if (fromFeedTopVar > 0) return fromFeedTopVar

  const scopeRowBottom = readCssPxVar(MEETING_GROUP_SCROLL_OFFSET_VAR) || DEFAULT_FEED_TOP_PX
  const presetBand = readCssPxVar(MEETINGS_PRESET_TABS_BAND_VAR)
  return scopeRowBottom + presetBand
}

const getMeetingsScrollElement = (element?: HTMLElement | null): HTMLElement | null => {
  const shellScroll = getShellContentScrollElement()
  if (shellScroll) return shellScroll

  let node = element?.parentElement ?? null
  while (node) {
    const { overflowY } = window.getComputedStyle(node)
    if (/(auto|scroll|overlay)/.test(overflowY) && node.clientHeight > 0) return node
    node = node.parentElement
  }

  return null
}

/** Scroll so the element's top edge sits on the meeting-table line (below preset row). */
export const scrollElementToMeetingsFeedTop = (
  element: HTMLElement,
  smooth = false,
): void => {
  if (typeof window === 'undefined') return

  const feedTop = getMeetingsFeedTopPx()
  const rect = element.getBoundingClientRect()
  const delta = rect.top - feedTop
  if (Math.abs(delta) < 1) return

  const scrollEl = getMeetingsScrollElement(element)
  const behavior = smooth ? 'smooth' : 'auto'

  if (scrollEl) {
    scrollEl.scrollTo({ top: scrollEl.scrollTop + delta, behavior })
    return
  }

  window.scrollBy({ top: delta, left: 0, behavior })
}
